:host {
  display: block;
}

.space-info-header {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 20px 20px 10px;
}

.space-info-title {
  text-overflow: ellipsis;
  line-height: 1.2em;
  font-size: 18px;
  overflow: hidden;
}

.space-info-category {
  font-size: 10px;
  color: #666666;
  letter-spacing: 1px;
  text-transform: uppercase;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 12px;
  margin-bottom: 2px;
}

.space-info-price { font-size: 12px; text-align: right; }

.space-info-price .price { font-size: 16px; white-space: nowrap; }

.space-info-price .price-type { font-size: 12px; }

.space-info-price .peak-price { margin-top: 5px; }

.space-info-features {
  margin-top: 10px;
  font-size: 12px;
  display: flex;
  gap: 15px;
  align-items: center;
  flex-wrap: wrap;
}

.space-info-features-capacity, 
.space-info-features-size,
.space-info-features-location {
  display: flex;
  align-items: flex-end;
  gap: 3px;
}

.space-info-features .icon {
  width: 14px;
  height: 14px;
  color: #666;
  margin-bottom: 1px;
}


.space-info-description {
  font-size: 13px;
  letter-spacing: 0.4px;
  white-space: pre-wrap;
  padding: 10px 20px 20px;
}

.space-info-description-show-button {
  background: none;
  outline: none;
  border: none;
  color: var(--tambr-accent-color, #000000);
  font-size: inherit;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
  transition: opacity 0.2s;
}

.space-info-description-show-button:hover { opacity: 0.7; }

.space-info-description-spacer { padding: 0 4px; }